import React from "react";
import Icon from "@mdi/react";
import { mdiAlertCircleOutline } from "@mdi/js";
import { Paper, Box, Typography, Button } from "@mui/material";

class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("🔥 Caught by GlobalErrorBoundary:", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
          bgcolor="#f9f9f9"
          flexDirection="column"
        >
          <Paper
            elevation={3}
            style={{ padding: "40px", borderRadius: 16, textAlign: "center" }}
          >
            <Icon
              path={mdiAlertCircleOutline}
              style={{ fontSize: 60, color: "#f44336", marginBottom: 16 }}
            />
            <Typography variant="h6" gutterBottom>
              Une erreur est survenue 😔
            </Typography>
            <Typography variant="body1" color="textSecondary" gutterBottom>
              Veuillez patienter quelques instants pendant que nous rétablissons
              la page.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleReload}
              style={{ marginTop: 20 }}
            >
              Recharger la page
            </Button>
          </Paper>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;
